<template>
  <ReportsPage
    :forecast-subscription="forecastSubscription"
    :market-assessment-subscription="marketAssessmentSubscription"
    :prices-assessment-subscription="subscription"
    :product-data="productData"
    :product="product"
    :show-latest-report-section-in-market-assessments="true"
    :show-latest-report-section-in-price-assessments="false"
  >
    <NuxtPage
      :forecast-subscription="forecastSubscription"
      :market-assessment-subscription="marketAssessmentSubscription"
      :prices-assessment-subscription="subscription"
      :product-data="productData"
      :product="product"
      :show-latest-report-section-in-market-assessments="true"
      :show-latest-report-section-in-price-assessments="true"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import ReportsPage from '~/components/market/ReportsPage.vue'
import lithiumIonBatteriesData from '~/constants/data-reports/lithium-ion-batteries'
import {
  LITHIUM_ION_BATTERIES,
  MARKET,
  SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES,
  SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT,
  SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES,
} from '~/constants/services/constants'

definePageMeta({ layout: 'services' })

const product = ref(LITHIUM_ION_BATTERIES)
const productData = ref(lithiumIonBatteriesData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES)
const marketAssessmentSubscription = ref(
  SUBSCRIPTION_MARKET_ASSESSMENTS_GIGAFACTORY_ASSESSMENT,
)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM_ION_BATTERIES)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${LITHIUM_ION_BATTERIES.name} Data and Reports`,
})
useHead(seo)
</script>
